import { View, type ViewStyle } from 'react-native';
import { Text } from 'app/design/primitives/text';

interface ProgressBarProps {
  percentage: number; // 0–100
  height?: number;
  width?: string | number;
  backgroundColor?: string;
  progressColor?: string;
  showLabel?: boolean;
}

export function ProgressBar({
  percentage,
  height = 10,
  width = '100%',
  backgroundColor,
  progressColor,
  showLabel,
}: ProgressBarProps) {
  const validPercentage = Math.max(0, Math.min(100, percentage));
  return (
    <View style={{ width: width, height: height } as ViewStyle}>
      <View
        style={{
          flex: 1,
          backgroundColor: backgroundColor ? `${backgroundColor}3D` : undefined,
          borderRadius: 5,
          overflow: 'hidden',
          marginRight: showLabel ? 8 : 0,
        }}
      >
        <View
          style={{
            flex: 1,

            width: `${validPercentage}%`,
            backgroundColor: progressColor,
            opacity: 1,
          }}
        />
      </View>
      {showLabel ? <Text>{`${validPercentage.toFixed(0)}%`}</Text> : null}
    </View>
  );
}

export default ProgressBar;
